<template>
  <div class="inter-container">
    <div class="tip-item">
      <div class="tip-item-title">{{$t('fund.title1')}}</div>
      <div class="tip-item-info">
        <p v-for="(item, index) in $t('fund.description1')" :key="index">{{ item }}</p>
      </div>
    </div>
    <div class="tip-item">
      <div class="tip-item-title">{{$t('fund.title2')}}</div>
      <div class="tip-item-info">
        <p>{{$t('fund.description2')}}</p>
        <p class="mgt10">{{$t('fund.description3')}}</p>
      </div>
    </div>
    <div class="tip-footer">
      <el-button @click="onToPath" type="primary">{{$t('fund.hadGreen')}}</el-button>
    </div>
  </div>
</template>

<script>
import { getTotalAttempts } from '@/api/v2/fund'
// import { Dialog } from 'mand-mobile'
export default {
  name: 'interRisk',
  data() {
    return {
      isFinish: false,
      attempts: {}
    }
  },
  created() {
    this.getTotalAttempts()
  },
  methods: {
    async onToPath() {
      if (!this.isFinish) {
        this.$loading.show() // 显示加载中
        await this.getTotalAttempts()
        this.$loading.hide() // 隐藏加载中
      }
      if (this.attempts.last30DaysAttemptTotal >= this.attempts.last30DaysMaxAttemptTotal) {
        this.$confirm(this.$t('fund.hadFiveTimes', { number: this.attempts.last30DaysMaxAttemptTotal }),
          {
          cancelButtonText: this.$t('common.cancel'),
          confirmButtonText: this.$t('fund.continueAssessment')
        }).then(res => {
          this.continueJudge()
        })
        return
      }
      this.continueJudge()
    },
    continueJudge() {
      if (this.attempts.currentDaysAttemptTotal >= this.attempts.currentDaysMaxAttemptTotal) {
        this.$alert(this.$t('fund.useUpChange'), {
          cancelText: this.$t('common.knowIt')
        })
      } else if (this.attempts.currentDaysAttemptTotal < this.attempts.currentDaysMaxAttemptTotal) {
        this.$confirm(this.$t('fund.haveChanges', { number: this.attempts.currentDaysMaxAttemptTotal - this.attempts.currentDaysAttemptTotal }),
        {
          cancelButtonText: this.$t('common.cancel'),
          confirmButtonText: this.$t('common.knowIt')
        }).then(() => {
          this.$router.push('/risk-assessment')
        })
      }
    },
    onBack () {
      this.$jsBridge.isSupported('navBack')
          ? this.$jsBridge.run('navBack', { isClosePage: true })
          : this.$router.push('/')
    },

    async getTotalAttempts() {
      try {
        const { data } = await getTotalAttempts()
        this.attempts = data
        this.isFinish = true
        return data
      } catch (error) {
        this.isFinish = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.inter-container {
  padding: 0px 30px 30px;
  margin-top: 22px;
}
.tip-item{
  & + & {
    margin-top: 16px;
  }
}
.tip-item-title{
  margin-bottom: 12px;
  color: #1C212A;
  font-weight: 500;
  font-size: 16px;
}
.tip-item-info{
  margin-bottom: 16px;
  background: #fff;
  color: #83909D;
  padding: 12px;
  font-size: 14px;

}
.tip-item-info:last-child{
  margin-bottom: 0;
}
.mgt10{
  margin-bottom: 10px;
}
.tip-footer{
  text-align: right;
  margin-top: 20px;
}
</style>
